// Models the agent stack can run on — single-sourced in
// contracts/src/vocabulary.ts, shared with the backend (src/config/agentModels.ts).
// PROXY models are selectable only on deployments with the LiteLLM proxy
// configured (LITELLM_BASE_URL); the backend 400s the run/turn otherwise.
import type { AgentModel } from '../../contracts/dist/index.js';

export { AGENT_MODELS } from '../../contracts/dist/index.js';
export type { AgentModel } from '../../contracts/dist/index.js';

export const AGENT_MODEL_LABELS: Record<AgentModel, string> = {
  'claude-opus-5-5': 'Opus 5.5',
  'claude-opus-5': 'Opus 5',
  'claude-opus-4-8': 'Opus 4.8',
  'claude-opus-4-7': 'Opus 4.7',
  'claude-fable-5-1': 'Fable 5.1',
  'claude-fable-5': 'Fable 5',
  'gpt-6-astra': 'GPT-6 Astra (LiteLLM)',
  'gpt-5.6': 'GPT-5.6 (LiteLLM)',
  'deepseek-v4-pro': 'DeepSeek V4 Pro (LiteLLM)',
  'deepseek-v4-flash': 'DeepSeek V4 Flash (LiteLLM)',
  'kimi-k3': 'Kimi K3 (LiteLLM)',
  'kimi-k2.6': 'Kimi K2.6 (LiteLLM)',
};
